import { Block } from 'factories/block';

export const setBlockLocalAction = (block: Block) => {
  return {
    type: 'SET_BLOCK',
    data: block,
  };
};
